<template>
  <account-whatsapp />
</template>

<script>
import AccountWhatsapp from "./accountWhatsApp.vue";

export default {
  name: "licenseList",
  components: {
    AccountWhatsapp
  }
};
</script>



// WEBPACK FOOTER //
// src/views/license/listV2.vue